module.exports = __webpack_public_path__ + "media/img/Landing_Page/scholarship-03-82bb783d3a0970be5de57c26a1c4605a.jpg";